// src/services/features/attendance/attendanceSlice.js
// Admin / manager side of attendance (the app handles check-in / check-out).
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../API/api';

const msg = (e) => e.response?.data?.message || e.message;

// Records for a date range (from / to) + optional status / search
export const fetchAllAttendance = createAsyncThunk(
  'attendance/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await API.get('/api/attendance', { params });
      return data;
    } catch (e) {
      return rejectWithValue(msg(e));
    }
  }
);

// Counts per status for the same range
export const fetchAttendanceSummary = createAsyncThunk(
  'attendance/fetchSummary',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await API.get('/api/attendance/summary', { params });
      return data;
    } catch (e) {
      return rejectWithValue(msg(e));
    }
  }
);

// One employee's month: items + summary + attendance %
export const fetchMonthlyAttendance = createAsyncThunk(
  'attendance/fetchMonthly',
  async ({ employeeId, month } = {}, { rejectWithValue }) => {
    try {
      const { data } = await API.get('/api/attendance/monthly', {
        params: { employeeId, month },
      });
      return data;
    } catch (e) {
      return rejectWithValue(msg(e));
    }
  }
);

const slice = createSlice({
  name: 'attendance',
  initialState: {
    list: [],
    total: 0,
    summary: null,
    monthly: null,
    loading: false,
    monthlyLoading: false,
    error: null,
  },
  reducers: {
    clearMonthly: (s) => {
      s.monthly = null;
    },
  },
  extraReducers: (b) => {
    b
      .addCase(fetchAllAttendance.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(fetchAllAttendance.fulfilled, (s, a) => {
        s.loading = false;
        s.list = a.payload.items || [];
        s.total = a.payload.total ?? (a.payload.items || []).length;
      })
      .addCase(fetchAllAttendance.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload;
      })

      .addCase(fetchAttendanceSummary.fulfilled, (s, a) => {
        s.summary = a.payload;
      })

      .addCase(fetchMonthlyAttendance.pending, (s) => {
        s.monthlyLoading = true;
      })
      .addCase(fetchMonthlyAttendance.fulfilled, (s, a) => {
        s.monthlyLoading = false;
        s.monthly = a.payload;
      })
      .addCase(fetchMonthlyAttendance.rejected, (s, a) => {
        s.monthlyLoading = false;
        s.error = a.payload;
      });
  },
});

export const { clearMonthly } = slice.actions;
export default slice.reducer;

//------------ 13.10.2026 Backup --------------
// // src/services/features/attendance/attendanceSlice.js
// // Admin / manager side of attendance (the app handles check-in / check-out).
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import API from '../../API/api';

// const msg = (e) => e.response?.data?.message || e.message;

// // Records for a date range (from / to) + optional status / search
// export const fetchAllAttendance = createAsyncThunk(
//   'attendance/fetchAll',
//   async (params = {}, { rejectWithValue }) => {
//     try {
//       const { data } = await API.get('/api/attendance', { params });
//       return data;
//     } catch (e) {
//       return rejectWithValue(msg(e));
//     }
//   }
// );

// // Counts per status for the same range
// export const fetchAttendanceSummary = createAsyncThunk(
//   'attendance/fetchSummary',
//   async (params = {}, { rejectWithValue }) => {
//     try {
//       const { data } = await API.get('/api/attendance/summary', { params });
//       return data;
//     } catch (e) {
//       return rejectWithValue(msg(e));
//     }
//   }
// );

// // One employee's month: items + summary + attendance %
// export const fetchMonthlyAttendance = createAsyncThunk(
//   'attendance/fetchMonthly',
//   async ({ employeeId, month } = {}, { rejectWithValue }) => {
//     try {
//       const { data } = await API.get('/api/attendance/monthly', {
//         params: { employeeId, month },
//       });
//       return data;
//     } catch (e) {
//       return rejectWithValue(msg(e));
//     }
//   }
// );

// const slice = createSlice({
//   name: 'attendance',
//   initialState: {
//     list: [],
//     total: 0,
//     summary: null,
//     monthly: null,
//     loading: false,
//     monthlyLoading: false,
//     error: null,
//   },
//   reducers: {
//     clearMonthly: (s) => {
//       s.monthly = null;
//     },
//   },
//   extraReducers: (b) => {
//     b
//       .addCase(fetchAllAttendance.pending, (s) => {
//         s.loading = true;
//         s.error = null;
//       })
//       .addCase(fetchAllAttendance.fulfilled, (s, a) => {
//         s.loading = false;
//         s.list = a.payload.items || [];
//         s.total = a.payload.total ?? (a.payload.items || []).length;
//       })
//       .addCase(fetchAllAttendance.rejected, (s, a) => {
//         s.loading = false;
//         s.error = a.payload;
//       })

//       .addCase(fetchAttendanceSummary.fulfilled, (s, a) => {
//         s.summary = a.payload;
//       })

//       .addCase(fetchMonthlyAttendance.pending, (s) => {
//         s.monthlyLoading = true;
//       })
//       .addCase(fetchMonthlyAttendance.fulfilled, (s, a) => {
//         s.monthlyLoading = false;
//         s.monthly = a.payload;
//       })
//       .addCase(fetchMonthlyAttendance.rejected, (s, a) => {
//         s.monthlyLoading = false;
//         s.error = a.payload;
//       });
//   },
// });

// export const { clearMonthly } = slice.actions;
// export default slice.reducer;
